import type { FC, SVGProps } from 'react';

const BrokenCloudsIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.58985 3.75847C6.27505 2.09114 7.91473 0.916016 9.83073 0.916016C11.8186 0.916016 13.5093 2.18079 14.145 3.94896C15.9731 4.39027 17.3307 6.03585 17.3307 7.99935C17.3307 9.8031 16.1852 11.3376 14.5827 11.918C14.0023 13.5205 12.4677 14.666 10.6641 14.666H4.29735C2.29073 14.666 0.664062 13.0393 0.664062 11.0327C0.664062 9.57701 1.51959 8.32268 2.75446 7.74252C2.8541 5.93777 3.99751 4.41285 5.58985 3.75847ZM7.76848 3.43664C9.5639 3.60669 11.0566 4.81213 11.645 6.44893C13.2837 6.84451 14.5444 8.20785 14.788 9.90035C15.3242 9.44151 15.6641 8.75968 15.6641 7.99935C15.6641 6.70193 14.6751 5.63453 13.4106 5.51128C13.0517 5.47632 12.7561 5.21462 12.6779 4.86274C12.3878 3.55783 11.2221 2.58268 9.83073 2.58268C9.02598 2.58268 8.29656 2.90885 7.76848 3.43664ZM7.33073 5.08268C7.03466 5.08268 6.75034 5.12653 6.48311 5.20752C5.28485 5.57071 4.41406 6.68443 4.41406 7.99935C4.41406 8.08426 4.41767 8.16826 4.42472 8.25102C4.4592 8.65593 4.1965 9.02668 3.803 9.12843C2.95565 9.3476 2.33073 10.1182 2.33073 11.0327C2.33073 12.1188 3.21122 12.9993 4.29737 12.9993H10.6641C11.8506 12.9993 12.8459 12.1719 13.1007 11.0618C13.1421 10.8818 13.1641 10.6937 13.1641 10.4993C13.1641 9.20193 12.1751 8.13452 10.9106 8.01127C10.5517 7.97635 10.2561 7.7146 10.1779 7.36277C9.88781 6.05783 8.72215 5.08268 7.33073 5.08268Z"
        fill="#2C2543"
      />
    </svg>
  );
};

export default BrokenCloudsIcon;
